import React from 'react'
import './Style/Header.css'
import Logo from '../Image/logo.png'
function Header({date,productNumber}) {
  return <div className='header'>

        
        <div className='container'>
            <div className='row'>
                <div className='col-md-4 col-sm-12 col-xs-12 header-left-side'>
                    <img src={Logo} alt=''/>
                    <h3> Brand Name </h3>
                    <p> TAGLING SPACE HEAR </p>
                </div>
                <div className='col-md-8 col-sm-12 col-xs-12 header-right-side'>
                    <div className='invoice-number'>
                        <h1> INVOICE </h1>
                        <div className='data'>
                            <p> invoice number : #{productNumber.productNumber} </p>
                            <p> Date : {date} </p>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
  </div>
}

export default Header